import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Solutions from "@/pages/Solutions";
import Platforms from "@/pages/Platforms";
import Blueprint from "@/pages/Blueprint";
import Architecture from "@/pages/Architecture";
import Contact from "@/pages/Contact";
import SubdomainPreview from "@/subdomains/SubdomainPreview";
import SubdomainIndex from "@/subdomains/SubdomainIndex";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Subdomain landing page previews (dev) — SmartCampus excluded */}
          <Route path="/sites" element={<SubdomainIndex />} />
          <Route path="/sites/:slug" element={<SubdomainPreview />} />

          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/platforms" element={<Platforms />} />
            <Route path="/blueprint" element={<Blueprint />} />
            <Route path="/architecture" element={<Architecture />} />
            <Route path="/contact" element={<Contact />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors closeButton />
    </div>
  );
}

export default App;
